module.exports = __webpack_public_path__ + "dist/img/buyathome.97214445.png";